import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { mapObjIndexed, pick } from "ramda";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { useMutation, useQuery } from "./services/hooks";

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const FRONT_PATH = "front.n.histmag.org";

const DataQuery = {
  article: ["editable_articles?id=eq.$id", false],
};
const CreateQuery = ["articles", "POST"];
const UpdateQuery = ["articles?id=eq.$id", "PATCH"];

const Crop = ({ src, cropPoints, onChange, hidePreview, orientation }) => {
  const [dataurl, setDataurl] = useState("");
  const cropperRef = useRef(null);
  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    onChange(cropper.getData());
    if (cropper && cropper.getCroppedCanvas())
      setDataurl(cropperRef.current.cropper.getCroppedCanvas().toDataURL());
  };

  const data = cropPoints || null;

  return (
    <>
      <Cropper
        src={src}
        style={{ height: 400, width: "100%" }}
        crop={onCrop}
        ref={cropperRef}
        data={data}
        autoCrop={true}
        autoCropArea={1}
        viewMode={1}
        aspectRatio={orientation}
      />
      {!hidePreview && (
        <div
          style={{
            width: 900,
            height: 600,
          }}
        >
          <img
            style={{
              objectFit: "cover",
              height: 600,
            }}
            src={dataurl}
          />
        </div>
      )}
    </>
  );
};

export default () => {
  const { id } = useParams();
  const [res1, updateArt] = useMutation(UpdateQuery);
  const [{ data, loading, error }] = useQuery({
    query: DataQuery,
    variables: {
      id: parseInt(id),
    },
  });
  const [step, setStep] = useState(1)
  const [fbimage, setFbImage] = useState('')
  const [insideImage, setInsideImage] = useState('')
  const [isVertical, setIsVertical] = useState('HORIZONTAL')

  const [cropfbImage, setCropFbImage] = useState(null)
  const [crop32, setCrop32] = useState(null)
  const [crop11, setCrop11] = useState(null)

  const secondStep = () => {
    setFbImage(
        fbimage.replace(
            "https://fs.new.histmag.org/view",
            "https://histmag.org",
        )
    )
    setInsideImage(
        insideImage.replace(
            "https://fs.new.histmag.org/view",
            "https://histmag.org",
        )
    )
    setIsVertical(
        isVertical === 'HORIZONTAL' ? false : true
    )
    setTimeout(() => {
        setStep(2)
    }, 500)
  }

  const save = () => {
    updateArt({
        id: parseInt(id),
        data: {
            fb_image: fbimage,
            inside_image: insideImage,
            croppoints: {
                isVertical,
                version32: crop32,
                version11: crop11,
                fb_image: cropfbImage
            }
        }
    })

    setTimeout(() => {
        fetch(
          `https://${FRONT_PATH}/api/revalidate?secret=asdnjksdnfuiaoenwu&path=/${data.article.slug}-${id}`,
        );
        fetch(
          `https://${FRONT_PATH}/api/revalidate?secret=asdnjksdnfuiaoenwu&path=/`,
        );
      }, 1500);

      setTimeout(() => {
        window.location.href = `/articles/${id}`
      }, 2500);
  }

  const anyImage = insideImage || fbimage

  if (loading || error || !data) return <div>Ładowanie...</div>;
  return (
    <div className='p-4'>
        {step === 1 && <div>
            0. Obecne obrazki<br />
            SOCIAL: {data.article.fb_image}<br />
            SERWIS: {data.article.inside_image}<br />
<br />
            1. Wybierz obrazki<br />
            Social:<br />
            <input className='border' type='text' value={fbimage} onChange={e => setFbImage(e.target.value)} /><br />
        <br />
            Serwis:<br />
            <input className='border' type='text' value={insideImage} onChange={e => setInsideImage(e.target.value)} /><br />
<br />
            <select value={isVertical} onChange={e => setIsVertical(e.target.value)} >
                <option value={'VERTICAL'}>pionowy</option>
                <option value={'HORIZONTAL'}>poziomy</option>
            </select>
            <div style={{
              padding: 10,
              border: '1px solid black'
            }} onClick={() => {
                        secondStep()
                      }}>NEXT STEP</div>
        </div>}
      

        {step === 2 && <div>

            <div>SOCIAL</div>
            <Crop
                onChange={(data) => setCropFbImage(data)}
                src={fbimage}
                cropPoints={cropfbImage}
            />
            <div>INSIDE IMAGE 3:2</div>
                      <Crop
                        hidePreview
                        orientation={
                          isVertical ? 2 / 3 : 3 / 2
                        }
                        onChange={(data) => setCrop32(data)}
                        src={anyImage}
                        cropPoints={crop32}
                      />
                      <div>INSIDE IMAGE 1:1</div>
                      <Crop
                        hidePreview
                        orientation={1}
                        onChange={(data) => setCrop11(data)}
                        src={anyImage}
                        cropPoints={crop11}
                      />
                      <div style={{
              padding: 10,
              border: '1px solid black'
            }} onClick={() => {
                        console.log({
        id: parseInt(id),
        fb_image: fbimage,
        inside_image: insideImage,
        croppoints: {
            isVertical,
            version32: crop32,
            version11: crop11,
            fb_image: cropfbImage
        }
    })
    save()
                      }}>SAVE</div>
        </div>}
    </div>
  );
};
